import { WS_ACL_REVOKE_REASONS } from 'cpool-constants';
import { z } from 'zod';

/** Payload of the `ws:acl-revoke:{userId}` pub/sub channel — every open socket of that user must
 *  re-verify or close. */
export const schemaWsAclRevokeMessage = z.object({
    reason: z.nativeEnum(WS_ACL_REVOKE_REASONS).optional(),
    userId: z.string().min(1),
});

export type Schema_WsAclRevokeMessage = z.infer<typeof schemaWsAclRevokeMessage>;
